module.exports = __webpack_public_path__ + "2bfd161d26f6910a735b4c2b18ad2aa2.pdf";